import { createFileRoute, redirect } from '@tanstack/react-router'
import React from 'react'
import { PortaledBreadcrumb } from '../components/portaled-breadcrumb'
import { usePagination } from '../hooks/use-pagination'
import { searchQuery } from '../zod/pagination'
import { useTranslation } from 'react-i18next'
import { INDEX_COMPANY } from '../user/permission'
import { useTitle } from '../hooks/use-title'
import { useCompanies } from '../company/hooks'
import { CompanyTable } from '../company/components/company-table'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/companies/')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(INDEX_COMPANY)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    validateSearch: searchQuery,
    component: Companies,
})

function Companies() {
    const { t } = useTranslation()
    const search = Route.useSearch()

    const tableProps = usePagination(useCompanies, { query: search })
    useTitle(t('Companies'))

    const total = tableProps.pagination ? tableProps.pagination.total : undefined

    return (
        <>
            <PortaledBreadcrumb
                items={[
                    {
                        title: t('Companies'),
                    },
                ]}
            />
            <PageTitle
                title={t('Companies')}
                subtitle={t('Every company on the platform.')}
                count={total}
                countLoading={tableProps.loading === true}
                className="mb-6"
            />
            <CompanyTable {...tableProps} />
        </>
    )
}
